import { ClipboardCheck, Truck, Users } from 'lucide-react';

export const UseCaseOverview = () => {
  const benefits = [
    {
      icon: ClipboardCheck,
      title: "All-in-One Planning",
      description: "Menus, inventory, and orders in one system"
    },
    {
      icon: Truck,
      title: "Sysco Integration",
      description: "Auto-generate CSV purchase orders instantly"
    },
    {
      icon: Users,
      title: "Volunteer-Friendly",
      description: "Simple enough for part-time or seasonal staff"
    }
  ];

  return (
    <section id="use-case-intro" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#F5F1E8]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate mb-4">
            Built for Every Kind of Camp
          </h2>
          <p className="text-lg text-slate/80 max-w-3xl mx-auto">
            CampChef Pro adapts to your kitchen — whether you're feeding 50 retreat guests or 500 hungry campers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg text-center animate-fade-in hover:shadow-xl transition-shadow"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-deep-teal/10 mb-6">
                  <Icon className="h-8 w-8 text-deep-teal" />
                </div>
                <h3 className="text-xl font-bold text-slate mb-3">
                  {benefit.title}
                </h3>
                <p className="text-slate/80 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
